import React, { useEffect } from "react";
import "./LoadingPage.css";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { fAuth } from "../../firebase";

const LoadingPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    onAuthStateChanged(fAuth, (user) => {
      if (user) {
        navigate("/dashboard");
      } else {
        navigate("/login");
      }
    });
  }, [navigate]);
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export default LoadingPage;
